import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import { getUserTimeZoneDateTimeLanguageBased } from '../../helpers/dateHelper';
import PanelCard from '../panel-card/panel-card';
import UserImage from '../user-image/user-image';
import './comment-section.scss';
import getInitials from '../../helpers/utils';
import CommentEditor from '../text-editor/comment-editor';
import NoData from '../no-data/no-data';

function CommentSection({
  isEditor,
  showComment,
  commentData,
  profileDetail,
  ...rest
}) {
  const data = commentData?.comment?.trim();
  const [t] = useTranslation('managebooking');

  return (
    <PanelCard className={showComment ? 'border-style' : ''}>
      {!isEditor ? (
        <div className="d-flex align-center comment-container pb-15">
          <UserImage
            size="small"
            shortName={getInitials(commentData?.userName)}
            path={commentData?.profile}
          />
          <h4 className="pl-8 username m-0">{commentData?.userName}</h4>
        </div>
      ) : (
        <div className="d-flex align-center comment-container pb-15">
          <UserImage
            size="small"
            shortName={`${profileDetail?.data?.firstName
              ?.charAt(0)
              .toUpperCase()}
          ${profileDetail?.data?.lastName?.charAt(0)?.toUpperCase()}`}
            path={profileDetail?.data?.profilePicture}
            removeTooltip
          />
          <h4 className="pl-8 username m-0">{`${profileDetail?.data?.firstName} ${profileDetail?.data?.lastName}`}</h4>
        </div>
      )}
      {!isEditor ? (
        <>
          <div className="comments">
            {showComment}
            {data === '' ? (
              <NoData
                smallHeight
                message={t(
                  'managebookingscreen.bookingdetails.comment.nocomment'
                )}
                bg
              />
            ) : (
              ReactHtmlParser(data)
            )}
          </div>
          {data && (
            <span className="timezone">
              {getUserTimeZoneDateTimeLanguageBased(commentData?.createdDate)}
            </span>
          )}
        </>
      ) : null}
      {isEditor && (
        <CommentEditor
          {...rest}
          placeholder={t(
            'managebookingscreen.bookingdetails.comment.placeholder'
          )}
        />
      )}
    </PanelCard>
  );
}

CommentSection.propTypes = {
  isEditor: PropTypes.bool,
  showComment: PropTypes.bool,
  commentData: PropTypes.objectOf(PropTypes.string),
  profileDetail: PropTypes.instanceOf(Object),
};

CommentSection.defaultProps = {
  isEditor: false,
  showComment: true,
  commentData: {},
  profileDetail: {},
};

function mapStateToProps(state) {
  return {
    profileDetail: state.omniProfile.profileDetail.fetchProfileDetails,
  };
}

export default connect(mapStateToProps, null)(CommentSection);
